import { EventMeta } from '../../../interfaces/meta.interface';

type TIUrlClickDataDescFields = {
    Url: string;
};

const tIUrlClickData: EventMeta<any, TIUrlClickDataDescFields> = {
    title: 'Malicious URL Clicked',
    default: {
        description: 'Malicious URL Clicked',
        longDescription: 'A Malicious URL was clicked.',
        severity: 'info',
    },
    descriptionExtractor: (log: any) => {
        return {
            Url: log.Url,
        };
    },
    classifications: [
        {
            severity: 'critical',
            description: (fields) => `A malicious URL (${fields.Url}) clicked in email`,
            longDescription: (fields) =>
                `A malicious URL (${fields.Url}) was clicked within an email. This action may indicate a phishing attempt or an effort to deliver malware. The click suggests a potential compromise risk and should be investigated to ensure no further damage occurred.`,
        },
    ],
};

export default tIUrlClickData;
